export function usesEmbeddedConsole() {
  const env = process.env.FORCE_NODE_ENV;
  return env !== undefined && env !== "local-development";
}

export function getConsoleGatewayUrl(vmId, accountId) {
  const query = `pcb=${encodeURIComponent(String(vmId))}&user=${encodeURIComponent(String(accountId))}`;
  return `/wsgate?${query}`;
}
